import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import type { PaletteMode } from "@mui/material";
import MuiAlert from "./components/MuiAlert";
import MuiAutocomplete from "./components/MuiAutocomplete";
import MuiAvatar from "./components/MuiAvatar";
import MuiBackdrop from "./components/MuiBackdrop";
import MuiBreadcrumbs from "./components/MuiBreadcrumbs";
import MuiButton from "./components/MuiButton";
import MuiCheckbox from "./components/MuiCheckbox";
import MuiChip from "./components/MuiChip";
import MuiDialog from "./components/MuiDialog";
import MuiDialogActions from "./components/MuiDialogActions";
import MuiDialogContent from "./components/MuiDialogContent";
import MuiDialogTitle from "./components/MuiDialogTitle";
import MuiListItem from "./components/MuiListItemButton";
import MuiListItemIcon from "./components/MuiListItemIcon";
import MuiListItemSecondaryAction from "./components/MuiListItemSecondaryAction";
import MuiMenuItem from "./components/MuiMenuItem";
import MuiMenuList from "./components/MuiMenuList";
import MuiSelect from "./components/MuiSelect";
import MuiTextField from "./components/MuiTextField";

export function createAppTheme(mode: PaletteMode) {
  const base = createTheme(
    {
      palette: {
        mode,
        primary: {
          main: mode === "light" ? "rgba(70, 128, 216, 1)" : "rgba(100, 160, 240, 1)",
        },
        background: {
          default: mode === "light" ? "rgba(250, 250, 250, 1)" : "rgb(18, 18, 18)",
          paper: mode === "light" ? "rgba(255, 255, 255, 1)" : "rgb(30, 30, 30)",
        },
      },
    },
    {
      components: {
        ...MuiAlert,
        ...MuiAutocomplete,
        ...MuiAvatar,
        ...MuiBackdrop,
        ...MuiButton,
        ...MuiCheckbox,
        ...MuiChip,
        ...MuiDialog,
        ...MuiDialogActions,
        ...MuiDialogContent,
        ...MuiDialogTitle,
        ...MuiListItem,
        ...MuiListItemIcon,
        ...MuiListItemSecondaryAction,
        ...MuiMenuItem,
        ...MuiMenuList,
        ...MuiSelect,
        ...MuiTextField,
        ...MuiBreadcrumbs,
      },
    },
  );

  return responsiveFontSizes(base);
}
